import {fetchHelpPageSuccess} from "modules/actions/help";
import {HelpPages} from "modules/enums";
import {createReducer} from "redux-act";

type TState = Required<ReturnType<typeof fetchHelpPageSuccess>["payload"]>;

const defaultPage: TState[HelpPages] = {
	id: 0,
	type: "",
	title: "",
	text: "",
};

const initialState: TState = {
	[HelpPages.HOW_TO_PLAY]: defaultPage,
	[HelpPages.TERMS]: defaultPage,
	[HelpPages.PRIZES]: defaultPage,
	[HelpPages.MULLIGAN]: defaultPage,
};

export const help = createReducer({}, initialState).on(fetchHelpPageSuccess, (state, payload) => ({
	...state,
	...payload,
}));
